import { faBell, faCalendarWeek, faHouse, faMapLocation } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FunctionalComponent } from 'preact';
import { getCurrentUrl, Link } from 'preact-router';

import RoundCount from '@/components/RoundCount';
import { useUnreadBellNotificationCount } from '@/hooks/notifications';

import useScheduleCount from './hooks/useScheduleCount';
import style from './style.scss';

const activeClass = (path: string) => (getCurrentUrl().includes(path) ? style.active : undefined);

const MobileTabs: FunctionalComponent = () => {
  const notificationCount = useUnreadBellNotificationCount();
  const scheduleCount = useScheduleCount();

  return (
    <nav className={style.mobileTabs}>
      <ul>
        <li>
          <Link className={activeClass('/home')} href="/home">
            <FontAwesomeIcon icon={faHouse} />
          </Link>
        </li>
        <li>
          <Link data-tour-id="habitatsTab" className={activeClass('/habitats')} href="/habitats">
            <FontAwesomeIcon icon={faMapLocation} />
          </Link>
        </li>
        <li>
          <Link className={activeClass('schedule')} href="/schedule">
            <FontAwesomeIcon icon={faCalendarWeek} />
            {scheduleCount > 0 && <RoundCount count={scheduleCount} className={style.badge} />}
          </Link>
        </li>
        <li>
          <Link className={activeClass('/notifications')} href="/notifications">
            <FontAwesomeIcon icon={faBell} />
            {notificationCount > 0 && <RoundCount count={notificationCount} className={style.badge} />}
          </Link>
        </li>
      </ul>
    </nav>
  );
};

export default MobileTabs;
